<template>
  <div class="content Tabs">

     <b-tabs card>
          

          <b-tab v-if="source=='ProjectTable'||source=='ProjectDetails'" :title="lang.tab_NewProject"  :title-link-class="textColors" :title-item-class="textColors" active >

            <DeriveProjectFormComponent :lang="lang.DeriveProjectForm" :source="source"></DeriveProjectFormComponent>

          </b-tab>

          

        </b-tabs>

  </div>

</template>
<script>


import { mapGetters } from 'vuex'
import DeriveProjectFormComponent from '@/components/shared/DeriveProjectFormComponent'


export default {
  name: "Content",
  components: {
    DeriveProjectFormComponent,
    
    
    
  },
  props:{
    lang: Object
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),
    source(){

      return this.$route.query.source;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {


  },
  updated() {


  },
  watch: {

  }
}
</script>

<style scooped>
  #DeriveProjectFormComponent{
    width: 60%;
  }

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
  .categories{
    margin-left: 5px;
    margin-right: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDerive/Middle/Content/Content.vue